module.exports = __webpack_public_path__ + "img/bg2.725afc66.png";